var version = {
    "name":      "dativery",
    "buildDateCode": "20251126-220606",
    "buildDate": "Wed Nov 26 2025 22:06:06 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251126-220606",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;